export default __webpack_public_path__ + "static/anchor-01b-dont-16c086c9317312060cf82c797f4e641e6f77c4a45743b00d3e10c7816ba9a622.png";